import './style.css';
import { Game } from './game/Game';

new Game();
